import { gql } from '@apollo/client/core/index.js'

export const queries = {
  /**
   * getMntnMatchedSegments fetches data source 13, which contains MNTN Vertical Categorization segments.
   * Gary originally called it data source 13 MNTN_MATCHED.
   * In May 2024, Gary renamed data source 13 to MNTN_VERTICAL_CATEGORIZATION
   * and introduced MNTN_MATCHED as data source 19.
   * The GraphQL field was never renamed.
   * @see https://mntn.atlassian.net/wiki/spaces/TAR/pages/2195751100/Data+Sources+and+Categories
   */
  GET_VERTICALS: gql`
    query SELECT_GetVerticals($filter: MntnMatchedFilter) {
      getMntnMatchedSegments(filter: $filter) {
        verticalId: data_source_category_id
        name
      }
    }
  `,
}
